import { createSelector } from 'reselect';
import { initialState } from './reducer';

import { TEAM } from 'constants/keys';

/**
 * Direct selector to the language domain
 */

const selectTeamData = state => state[TEAM] || initialState;

/**
 * Select the language locale
 */

const selectTeamDataList = () =>
    createSelector( selectTeamData, newsState => newsState.datas );
const selectAttempts = () =>
    createSelector( selectTeamData, newsState => newsState.attempts );
const selectIsLoading = () => 
    createSelector( selectTeamData, newsState => newsState.isLoading );

const selectCostReportData = () =>
    createSelector(selectTeamData, state => state.costReportData);

const selectIsCostReportLoading = () =>
    createSelector(selectTeamData, state => state.isCostReportLoading);

const selectCostReportError = () =>
    createSelector(selectTeamData, state => state.costReportError);

const selectMonthlyReportData = () =>
    createSelector(selectTeamData, state => state.monthlyReportData);

const selectIsMonthlyReportLoading = () =>
    createSelector(selectTeamData, state => state.isMonthlyReportLoading);

export {
    selectTeamDataList,
    selectIsLoading,
    selectAttempts,
    selectCostReportData,
    selectIsCostReportLoading,
    selectCostReportError,
    selectMonthlyReportData,
    selectIsMonthlyReportLoading
};